import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getJobPostsInfo = async (HubIds: string[], ISICCodes: string[], ISCO4Codes: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {

    const { path, method } = endpoints.occupationAndSector.getJobPostsInfo;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, ISCO4Codes, Locations, fromQuarter, toQuarter, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};